<template>
  <industries>
    <template v-slot:hero>
      <Hero
        imageName="industries/industries-banner.jpg"
        altText="American Credit Business Loans"
      >
        <!-- landing-hero.jpeg -->
        <template>
          <h1>Industries Served</h1>
          <p>
            Just when business is going great, life hits you hard. Luckily, we
            hit back harder. American Credit offers
            <strong
              >equipment loans, working capital loans, and invoice
              financing</strong
            >
            to get you back on your feet and back to work asap. <br /><br />
            Browse through our most served industries, and learn how we assist
            business owners <strong>just like you</strong>, everyday.
          </p>
          <router-link to="/get-start?step=1" tag="button" class="cta"
            >Get a quote</router-link
          >
        </template>
      </Hero>
    </template>
    <template v-slot:grid-section>
      <IndustriesGrid :gridElements="industriesGrid">
        <template v-slot:title><span>Browse</span> Our Industries</template>
      </IndustriesGrid>
    </template>
    <template v-slot:first-row>
      <RowSection
        img-side="right"
        imageName="industries/Lei-li-formal.jpeg"
        altText="photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
        class="lei-section"
      >
        <template v-slot:content>
          <h2><span>American Credit:</span> The Difference You Can Trust</h2>
          <p>
            Your business is not JUST a business. It’s YOURS. It’s your
            livelihood. It’s your passion. American Credit completely
            understands this. We help business owners just like you everyday, by
            taking a wholistic approach to business financing.
            <strong>Dr. Lei Li, PhD, CFA, & CEO of American Credit</strong>, is
            an Economist who uses his 20+ years of industry experience to help
            business owners achieve their American Dream:
            <strong>successful business ownership</strong>. <br /><br />
            Whatever financial situation you’re in, American Credit has your
            back. Apply for your business loan today!
          </p>
        </template>
        <template v-slot:button-contact>
          <contact-info
            imageName="Lei_Li.png"
            altText="Lei's photo"
            title="Call Lei"
            contactType="Service"
            phoneNumber="650-885-8055"
            class="d-none d-md-flex"
          />
        </template>
      </RowSection>
    </template>
    <template v-slot:google-reviews>
      <div class="elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"></div>
    </template>
  </industries>
</template>

<script>
import Industries from "../components/layouts/Industries.vue";

import Hero from "../components/industries/Hero.vue";
import IndustriesGrid from "../components/industries/IndustriesGrid.vue";
import RowSection from "../components/industries/RowSection.vue";
import ContactInfo from "../components/industries/ContactInfo.vue";

export default {
  components: {
    Hero,
    Industries,
    IndustriesGrid,
    RowSection,
    ContactInfo,
  },
  data() {
    return {
      industriesGrid: [
        {
          title: "Commercial Trucking Loans",
          image: "industries/industries-commercial-trucking.jpg",
          routeName: "commercialTruckFinancing",
        },
        {
          title: "Business Loans for Contractors",
          image: "industries/industries-contractors.jpg",
          routeName: "loansForContractors",
        },
        {
          title: "Construction Loans for Businesses",
          image: "industries/industries-construction.jpg",
          routeName: "commercialConstructionLoans",
        },
        {
          title: "Business Loans for Manufacturers",
          image: "industries/industries-manufacturing.jpg",
          routeName: "businessManufacturingLoans",
        },
        {
          title: "Excavator Financing for Businesses",
          image: "industries/industries-excavation.jpg",
          routeName: "excavatorFinancingLoans",
        },
        {
          title: "Restaurant Business Loans",
          image: "industries/industries-restaurant.jpg",
          routeName: "loansForRestaurants",
        },
        {
          title: "Landscaping Business Loans",
          image: "industries/industries-landscaping.jpg",
          routeName: "loansForLandscapers",
        },
        {
          title: "Transportation Business Loans",
          image: "industries/industries-transportation.jpg",
          routeName: "transportationBusinessLoans",
        },
        {
          title: "Commercial Auto Loans for Businesses",
          image: "industries/industries-commercial-auto.jpg",
          routeName: "commercialVehicleLoans",
        },
        {
          title: "Farming Business Loans",
          image: "industries/industries-farming.jpg",
          routeName: "loansForFarmers",
        },
        {
          title: "Working Capital Financing",
          image: "industries/working-capital-financing.jpg",
          routeName: "workingCapitalFinancing",
        },
        {
          title: "Commercial Real Estate Loans",
          image: "industries/commercial-real-estate-loans.jpg",
          routeName: "commercialRealEstateLoans",
        },
      ],
    };
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Industries Served - Business Financing | American Credit";
    meta.content =
      "We offer business financing & equipment loans to many industries including construction, contracting, restaurants, trucking, landscaping & more! Apply today!";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// industries.vue?466d7a37